import propertiesLight from "../../../../contents/images/docs/user-guides/utm-segmentation/properties-light-mode.png";
import propertiesDark from "../../../../contents/images/docs/user-guides/utm-segmentation/properties-dark-mode.png";
import filtersLight from "../../../../contents/images/docs/user-guides/utm-segmentation/filters-light-mode.png";
import filtersDark from "../../../../contents/images/docs/user-guides/utm-segmentation/filters-dark-mode.png";
import breakdownLight from "../../../../contents/images/docs/user-guides/utm-segmentation/breakdown-light-mode.png";
import breakdownDark from "../../../../contents/images/docs/user-guides/utm-segmentation/breakdown-dark-mode.png";
import * as React from 'react';
export default {
  propertiesLight,
  propertiesDark,
  filtersLight,
  filtersDark,
  breakdownLight,
  breakdownDark,
  React
};